// extracted by mini-css-extract-plugin
export default {"itemModule":"FooterBlock_itemModule__0W7Cd","titleModule":"FooterBlock_titleModule__EJSrS","title":"FooterBlock_title__abpb5","description":"FooterBlock_description__s2sQQ"};